/**
 * Image Text Grid Section
 * Handles any dynamic behavior for the image-text-grid section
 */

class ImageTextGrid {
  constructor(section) {
    this.section = section;
    this.sectionId = section.dataset.sectionId;
    this.init();
  }

  init() {
    // Initialize any dynamic functionality here
    // For now, this section is purely CSS-driven
    console.log(`Image Text Grid section ${this.sectionId} initialized`);
  }
}

// Initialize all image-text-grid sections on the page
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="image-text-grid"]');
  sections.forEach(section => {
    new ImageTextGrid(section);
  });
});

// Shopify theme editor support
if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="image-text-grid"]');
    if (section) {
      new ImageTextGrid(section);
    }
  });
}
